import { render, staticRenderFns } from "./projectInformation.vue?vue&type=template&id=8a366226&scoped=true"
import script from "./projectInformation.vue?vue&type=script&lang=js"
export * from "./projectInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a366226",
  null
  
)

export default component.exports